module.exports = __webpack_public_path__ + "static/media/Paul Prasad.a936d460.png";